
function copyToClipboard(element) {
    var $temp = $("<input>");
    var oldValue = $(element).html();
    
    $("body").append($temp);
    $temp.val($(element).html()).select();
    document.execCommand("copy");
    $(element).html("COPIADO");
    setTimeout(function(){ $(element).html(oldValue); }, 300);
    $temp.remove();
  
} 
  
$('cupom').click(function(){
    copyToClipboard(this);
});

document.addEventListener("DOMContentLoaded", function() {
  var lazyVideos = [].slice.call(document.querySelectorAll("video.lazy"));

  if ("IntersectionObserver" in window) {
    var lazyVideoObserver = new IntersectionObserver(function(entries, observer) {
      entries.forEach(function(video) {
        if (video.isIntersecting) {
          for (var source in video.target.children) {
            var videoSource = video.target.children[source];
            if (typeof videoSource.tagName === "string" && videoSource.tagName === "SOURCE") {
              videoSource.src = videoSource.dataset.src;
            }
          }

          video.target.load();
          video.target.classList.remove("lazy");
          lazyVideoObserver.unobserve(video.target);
        }
      });
    });

    lazyVideos.forEach(function(lazyVideo) {
      lazyVideoObserver.observe(lazyVideo);
    });
  }
});

(function(){
  const containers = ['#quickSearchResults','.quickSearchResults','#quick-search-results','.quick-search__results','[data-quick-search]'];
  function hideInContainers(){
    containers.forEach(sel=>{
      document.querySelectorAll(sel + ' .flex-price-parcel').forEach(el=>{
        el.style.setProperty('display','none','important');
        el.style.setProperty('visibility','hidden','important');
      });
    });
  }
  hideInContainers();
  const observer = new MutationObserver(hideInContainers);
  observer.observe(document.body, {childList:true, subtree:true});
})();